import { render } from "./News.vue?vue&type=template&id=5d2e0d22"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
script.render = render

export default script